// login-view.js
// dashboard-view.js

import $ from 'jquery';
import _ from 'lodash';
import util from 'util/Util';
import { View } from 'backbone';

import contentTemplate from 'sign-up-view.ejs';
import restService from 'RestService.js';
import NotificationService from 'NotificationService.js';

class SignUpView extends View {

    initialize( opts ) {
        this.options = opts || {};

        this.template = contentTemplate;
        
        $(this.el).off('click');

        this.events = {
            'click #signUp': 'signUpUser',
            'click #backToLogin': 'backToLogin'
        };
        this.model.set('errorMessage', '');
        this.model.set('firstName', '');
        this.model.set('lastName', '');
        this.model.set('email', '');
        this.model.set('password', '');
        this.model.set('confirmPassword', '');

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    render() {
        $(this.el).html(this.template(this.model.toJSON()));
        $(this.el).parent().addClass('blue-background');
        this.delegateEvents();
        return this;
    }
     backToLogin(ev){
        ev.preventDefault();
        Backbone.history.loadUrl('login');
     }

    signUpUser(e){
        e.preventDefault();
        const
         model = this.model,
         firstName = $('#firstName'),
         lastName = $('#lastName'),
         email = $('#email'),
         password = $('#password'),
         confirmPassword = $('#confirmPassword'),
         acceptTerms = $('#acceptTerms'),
         errorLog=$('#errorLog');

        if(firstName.val() === ''){
           errorLog.text('Please enter your First Name.').addClass('text-danger');
        }
        else if(lastName.val() === ''){
            errorLog.text('Please enter your Last Name.').addClass('text-danger');
        }
        else if(lastName.val() === ''){
            errorLog.text('Please enter your Last Name.').addClass('text-danger');
        }
        else if(!util.validateEmail(email.val())){
            errorLog.text('Please enter a valid email.').addClass('text-danger');
        }
        else if(password.val().length < 6){
            errorLog.text('Please enter a password of at least 6 characters.').addClass('text-danger');
        }
        else if(confirmPassword.val() !== password.val()){
            errorLog.text('"Password" and "Confirm Password" do not match.').addClass('text-danger');
        }
        else if(!acceptTerms.prop('checked')){
            errorLog.text('Please check that you agree to the "terms and conditions"').addClass('text-danger');
        }
        else{
            model.set('firstName', firstName.val());
            model.set('lastName', lastName.val());
            model.set('email', email.val());
            model.set('password', password.val());
            model.set('confirmPassword', confirmPassword.val());

            restService.signUp(model).then(function(){
                NotificationService.success("User was successfully created.");
            }).catch((error) => {
                const msg = error || 'Unknown Error';
                NotificationService.error(msg);
            });
        }
    }
}

export default SignUpView;
